import { enumToOptions } from "../../common/enum/util";

export enum MadoVatCodeLineTypeEnum {
    BASE = 'base',
    CALCULATED = 'calculated',
}

export const madoVatCodeLineTypeOptions = enumToOptions(MadoVatCodeLineTypeEnum, 'organization-settings.mado.vatCodeLine.type.');
